import _ from 'lodash'
import React from 'react'
import classnames from 'classnames'
import { NavLink } from 'react-router-dom'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import Logo from '../logos/trapink'
import ButtonSecondary from '../buttons/secondary'

library.add(faCaretDown);

class NavPrimary extends React.Component {
  constructor() {
    super();

    this.state = {
      menuIsActive: false,
      menuIsHovered: false
    }
  }

  handleMenuClick() {
    const _className = "menu-is-active";
    const _menuIsActive = this.state.menuIsActive;

    if (_menuIsActive) {
      document.body.classList.remove(_className);
    } else {
      document.body.classList.add(_className);
    }

    this.setState({
      menuIsActive: !_menuIsActive
    })
  }

  handleNavClick() {
    if (this.state.menuIsActive) {
      document.body.classList.remove('menu-is-active');

      this.setState({
        menuIsActive: false
      })
    }
  }

  renderNav() {
    return _.map(this.props.pages, (page, key) => {
      if (!page.parent) {
        let hasSubNav = false;
        const subNavItems = _.map(this.props.pages, (subPage, subKey) => {
          if (subPage.parent === page.id) {
            hasSubNav = true;
            return (
              <li className="subnav__item" key={ subKey }>
                <NavLink
                    className="subnav__link"
                    to={ '/team/' + subPage.slug }
                    >
                  { subPage.title.rendered }
                </NavLink>
              </li>
            )
          }
        })

        let subNav
        let caret

        if (hasSubNav) {
          subNav = <ul className="nav__subnav">{ subNavItems }</ul>
          caret = <FontAwesomeIcon icon={ faCaretDown } />
        }

        return (
          <li
              onMouseEnter={ () => { this.setState({ menuIsHovered: true }) } }
              onMouseLeave={ () => { this.setState({ menuIsHovered: false }) } }
              className={ classnames('nav__item', {'has-children': hasSubNav}) }
              key={ key }
          >
            <NavLink
                className={ classnames('nav__link', {dim: this.state.menuIsHovered}) }
                to={ '/' + page.slug }
                key={ key }
            >
              { page.title.rendered }
              { caret }
            </NavLink>
            { subNav }
          </li>
        )
      }
    });
  }

  render() {
    return (
      <div className="nav--wrapper">
        <nav className="js-nav nav nav-slide-left" onClick={ this.handleNavClick.bind(this) }>
          <div className="nav__header">
            <NavLink className="nav__logo-link" to="/">
              <Logo className="nav__logo" />
            </NavLink>
          </div>
          { this.renderNav() }
          <div className="nav__footer">
            <ButtonSecondary to="/contact">Appointments</ButtonSecondary>
          </div>
        </nav>

        <a className="menu" onClick={ this.handleMenuClick.bind(this) }>
          <div className="menu-hamburger"><span></span></div>
        </a>
      </div>
    );
  }
}

export default NavPrimary;



// WEBPACK FOOTER //
// ./src/components/nav/index.js